"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const image_1 = require("../../utils/image");
function mapToImageProps({ data, inHero }) {
    let media = null;
    let isSvg = false;
    if (data?.mediaReference && typeof data?.mediaReference === 'object') {
        media = data.mediaReference;
        isSvg = media?.mimeType === 'image/svg+xml';
    }
    if (!media || !media.url) {
        console.error('No valid media or URL found');
        return { data: '', srcFallback: '' };
    }
    return {
        isSvg,
        alt: media.alt || '',
        borderRadius: data.borderRadius,
        customPosition: data.customPosition,
        aspectRatio: data.aspectRatio,
        isImageCritical: inHero,
        srcFallback: (0, image_1.getMediaUrl)(media),
        data: {
            layout: 'constrained',
            width: media.width || 0,
            height: media.height || 0,
            images: {
                sources: [
                    {
                        sizes: `(min-width: ${media.width}px) ${media.width}px, 100vw`,
                        srcSet: (0, image_1.getMediaUrl)(media),
                        type: media.mimeType || '',
                    },
                ],
            },
            placeholder: {
                fallback: media.blurURL || undefined,
            },
        },
    };
}
exports.default = mapToImageProps;
